module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"device_title":"Device","unsubscribe_btn_text":"Unsubscribe"},"es":{"device_title":"Dispositivo","unsubscribe_btn_text":"Darse de baja"}}')
  delete Component.options._Ctor
}
